export default __webpack_public_path__ + "static/media/listadded_icon_bold.905ffa05.svg";